import { render, staticRenderFns } from "./NuevoTipoTurno.vue?vue&type=template&id=1f0f896e&scoped=true"
import script from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
export * from "./NuevoTipoTurno.vue?vue&type=script&lang=js"
import style0 from "./NuevoTipoTurno.vue?vue&type=style&index=0&id=1f0f896e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f896e",
  null
  
)

export default component.exports